import { store } from '../stores/mainStore';
import { DiceObject } from './DiceObject';

export class DiceHand {
	dice = [];
	diceLaunched = 0;
	group;
	diceUnlocked;

	constructor(mgr) {
		this.m = mgr; this.scene = this.m.scene;
		mgr.diceHand = this;

		const diceOldFullRes = 316;
		this.diceFullRes = 226;		// dice asset size
		const diceResRatio = this.diceFullRes / diceOldFullRes;
		const diceTargetSize = this.landscape ? 95 : 226;
		this.diceBigScale = diceTargetSize / this.diceFullRes;
		this.diceActualWidth = this.diceBigScale * this.diceFullRes;

		this.m.highlightScale = this.diceBigScale * 1.02 * 2 * diceResRatio; // 0.71;
		this.diceTinyScale = 0.4;
		this.diceEndScale = 2* 0.75 * (100 / 256) * 1.1;	// = 0.6445
		this.dice2DSmallScale = ((1.15 * this.diceEndScale) / 2) * (diceOldFullRes / this.diceFullRes);	// = 0.51819
		}
	create = () => {
		this.dice = Array.from(new Array(9), (_v, i) => new DiceObject(i, this.m));
		this.reCreate();
	};
	reCreate = () => {
		this.dice.forEach((d, ind) => {
			const pos = this.getDiceHomePosition(ind);
			//d.diceImage = this.scene.add.sprite(0, 0, 'dice2D_sheet').setFrame(6* d.diceNum);
			d.diceImage = this.scene.add.sprite(0, 0, 'dice2D_sheet').setFrame(d.currentFace);

			//  A Container has a default size of 0x0, so we need to give it a size before enabling a physics body
			d.diceContainer = this.scene.add.container(pos.x, pos.y, [d.diceImage])
				.setSize(d.diceImage.width, d.diceImage.height);

			d.frameNum = 0;
			d.currentFace = 0;
			d.locked = false;
			d.homePosition = { x: pos.x, y: pos.y };
			d.defaultHomePosition = { x: pos.x, y: pos.y };
			d.lastPosition = { x: 0, y: 0 };

			d.diceSprite = this.createDiceSprite(d, ind, this.diceBigScale)
				//.setInteractive()
			d.enableCollision(false)
	
			// no dice holding
			//d.diceSprite.on('pointerup', () => this.onPointerUp(d.diceNum));
			//d.diceSprite.on('pointerdown', () => this.onPointerDown(d.diceNum));
		})
	};
	createDiceSprite = (d, ind, scale) => {
		const res = this.scene.matter.add.gameObject(d.diceContainer)
			.setFriction(0.35).setBounce(0.6)
			.setScale(scale).setRectangle(128, 128)
		res.body.label = 'dice'+ind;
		res.body.inertia = Infinity;
		return res
	}

	fallDiceIntoCup = (cupX, cupY, onComplete = null) => {
		this.diceStatus = 'introToCup';
		let diceCount = this.dice.length;

		// set dice in top right corner out screen
		this.dice.forEach((d, i) => {
			d.diceSprite.setAlpha(1.0).setDepth(4)
				.setX(this.m.config.width)
				.setY(-120 * this.m.scaleFactor)
				.setScale(0.8 * this.m.scaleFactor * 2)
			d.enableCollision(false)

			this.scene.tweens.add({
				targets: [d.diceSprite],
				x: cupX, y: cupY, scale: 0.2 * this.m.scaleFactor * 2,
				ease: 'Linear', delay: (840 / 3) * i, duration: 840,
				onComplete: () => onAnimationComplete(d.diceNum)
			});		
		})
		const onAnimationComplete = num => {
			this.m.playAudio('die' + (num + 1));
			this.dice[num].diceSprite.setAlpha(0);
			if (--diceCount === 0) {
				//this.resetDicePriority();
				this.diceStatus = 'resolved';
				if(onComplete)	onComplete();
			}
	};
			}
	throwDiceFromCup = (cupX, cupY) => {
		this.diceLaunchPosition = { x:cupX, y: cupY };
		this.diceLaunched = 0;
		this.diceStatus = 'launching';
		}
	launchNextDice = () => {
		if (this.diceLaunched >= 9) return;

		const i = this.diceLaunched;
		const d = this.dice[i];
		if (d.locked) {
			d.frameNum = -1;
			return;
		}
		d.frameNum = 0;
		if(!store.pokerRush)
			//d.currentFace = store.activeMatch.currentHand.dice[i].showing;
			d.currentFace = store.activeMatch.currentHand.diceFaces[i];

		this.scene.matter.world.remove(d.diceSprite);
		d.diceSprite = this.createDiceSprite(d, i, this.diceTinyScale)
			.setX(this.diceLaunchPosition.x + d.tinyDeltaX)
			.setY(this.diceLaunchPosition.y + d.tinyDeltaY)
			//.setScale(this.diceTinyScale)
			.setAlpha(1.0);
		this.scene.tweens.add({ targets: [d.diceSprite],
			scale: this.diceEndScale * 2,
			ease: 'Linear', duration: 100
		});

		d.enableCollision(true)

		const diceVelocity = this.m.ui.cup.getDiceStartVelocity(i);
		d.diceSprite.setStatic(false)
			.setBounce(0.6).setFrictionAir(0.06)
			.setVelocity(diceVelocity.x, diceVelocity.y)
			.setAngularVelocity(0)
	};

	getDiceHomePosition = ind => {
		const gridX = ind % 3;
		const gridY = Math.trunc(ind / 3);
		//const diceTop = this.m.adjustY(852) * 0.25 - 10 * this.m.scaleFactor + 12;
		const diceTop = 0.3 * this.m.config.height
		const pad = this.diceActualWidth * (1 + 0.015);
		const diceLeft = this.m.config.width / 2 - pad;
		return { x: diceLeft + gridX * pad, y: diceTop + gridY * pad };
	};
	getBottom = () => this.getDiceHomePosition(7).y + this.diceActualWidth/2;

	setVisible = par =>	this.dice.forEach(d => d.diceSprite.setVisible(par))
	clearDiceOffScreen = () => {
		this.dice.forEach(d => {
			d.diceSprite.x = d.homePosition.x;
			d.diceSprite.y = d.homePosition.y;
			d.diceSprite.y -= this.m.config.height * 0.75;
		});
	};
	areDiceOffScreen = () => !this.dice.some(d => d.diceSprite.y > 0)

	darkenUnlockedDice = () => {
		this.dice.forEach(d => {
			if (!d.locked) {
				d.removeFlair();
				d.highlight = this.scene.add.sprite(d.diceSprite.x-1, d.diceSprite.y-1, 'flair')
					.setScale(this.m.highlightScale*1.01).setAlpha(0.4)
				// .setFrame(1);
			}
		});
	};
	clearDarkenedUnlockedDice = () => {
		this.dice.forEach(d => {
			if (d.highlight && d.highlight.alpha === 0.4) {
				d.removeFlair();
			}
		});
	};

	unlockAllDice = () => {
		this.dice.forEach(d => {
			d.locked = false;
			d.removeFlair();
		});
	};

	resetDicePriority = () => {
		this.dice.forEach(d => d.diceSprite.setDepth(0));
	};

	sortLockedDice = () => {
		var val;
		this.dice.forEach((d) => {
			d.lockedSortOrder = -1;
		});
		var index = 0;
		var sorter = (d) => {
			if (d.locked && this.getFaceValue(d) === val && d.lockedSortOrder < 0) {
				d.lockedSortOrder = index++;
			}
		};
		for (val = 15; val >= 0; val--) {
			this.dice.forEach(sorter);
		}
	};

	getFaceValue = (d) => {
		var diceValues = [
			[7, 3, 11, 5, 14, 9],
			[14, 4, 8, 15, 6, 7],
			[5, 12, 10, 2, 8, 13],
			[12, 10, 13, 4, 9, 2],
			[14, 3, 9, 6, 4, 11],
			[2, 3, 8, 6, 15, 12],
			[12, 7, 9, 13, 10, 5],
			[11, 6, 5, 14, 3, 4],
			[13, 11, 8, 10, 7, 2],
		];
		return diceValues[d.diceNum][d.currentFace];
	};

	diceInCupHaptic = () => {
		const hapticMsg =
			this.diceUnlocked < 4 ? 'haptic_lightImpact' :
			this.diceUnlocked < 7 ? 'haptic_mediumImpact' :
			'haptic_mediumImpact';
		const num = Math.floor(this.diceUnlocked / 3);
		const sfxName = this.diceUnlocked < 2 ? 'die1' : 
			this.diceUnlocked < 7 ? 'die4' : 'die9';
		this.m.playHaptic(hapticMsg, sfxName);
		for (let i = 0, delay = 70; i < num - 1; i++, delay += 70) {
			setTimeout(() => {
				this.m.playHaptic(this.hapticMsg);
			}, delay)
		}
	};
}
